export const Services = {
   "REPORTS": {
      "path": "https://rrapireports.azurewebsites.net/",
      "method": "Get",
      "descrp": "Reports Services"
   },
   "GET_REPORTS_ALL": {
      "path": "https://rrapireports.azurewebsites.net/",
      "method": "Get",
      "descrp": "method to obtain contacts and users related to the customer, for the modality of view and edition"
   },
   "GET_VISTA_REPORTES": {
      "path": "https://rrapireports.azurewebsites.net/",
      "method": "POST",
      "descrp": "method to obtain contacts and users related to the customer, for the modality of view and edition"
   },
   "DOWNLOAD_FILES": {
      "path": "https://servicereportapi.azurewebsites.net/report/dynamic/xlsx",
      "method": "GET",
      "descrp": "Dowload files"
   }
}